export default "__VITE_ASSET__866f7c17__"